/**
 * Adresse einer Fallstudie (/portfolio/<slug>) – Auftrag 2026-10-28, Paket 10.
 * Der Slug steht in `portfolio_projects.slug` (Migration 0027, im Admin
 * editierbar); fehlt er, wird er deterministisch aus dem Titel gebildet –
 * dieselbe Regel wie in der Migration.
 */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/&/g, "und")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function projectSlug(p: { slug?: string | null; title: string }): string {
  const s = (p.slug ?? "").trim();
  return s || slugify(p.title);
}

export function caseStudyPath(p: { slug?: string | null; title: string }): string {
  return `/portfolio/${projectSlug(p)}`;
}
